import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-home-horas-extras',
  templateUrl: './home-horas-extras.component.html',
  styleUrls: ['./home-horas-extras.component.css']
})
export class HomeHorasExtrasComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
